/**
 * Search overlay module.
 *
 * Opens the full-screen search overlay when .nav-search is clicked,
 * performs live AJAX search with debounce, renders grouped results.
 */

let debounceTimer = null;
const DEBOUNCE_MS = 400;
const MIN_CHARS = 2;

function initSearchOverlay() {
  const trigger = document.querySelector('.nav-search');
  const overlay = document.getElementById('search-overlay');

  if (!trigger || !overlay) {
    return;
  }

  const closeBtn = overlay.querySelector('.search-overlay-close');
  const input = overlay.querySelector('.search-overlay-input');
  const resultsContainer = overlay.querySelector('.search-overlay-results');

  function open() {
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      input.focus();
    });
  }

  function close() {
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  });

  closeBtn.addEventListener('click', close);

  overlay.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      close();
    }
  });

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      close();
    }
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      clearTimeout(debounceTimer);
      const query = input.value.trim();
      if (query.length >= MIN_CHARS) {
        resultsContainer.innerHTML = '<p class="search-overlay-loading">Searching&hellip;</p>';
        performSearch(query, resultsContainer);
      }
    }
  });

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = input.value.trim();

    if (query.length < MIN_CHARS) {
      resultsContainer.innerHTML = '';
      return;
    }

    resultsContainer.innerHTML = '<p class="search-overlay-loading">Searching&hellip;</p>';

    debounceTimer = setTimeout(() => {
      performSearch(query, resultsContainer);
    }, DEBOUNCE_MS);
  });
}

function performSearch(query, container) {
  // eslint-disable-next-line no-undef
  const { ajaxUrl, nonce } = airLightLoadMore;

  const body = new FormData();
  body.append('action', 'air_light_search_overlay');
  body.append('nonce', nonce);
  body.append('s', query);
  if (airLightLoadMore.lang) {
    body.append('lang', airLightLoadMore.lang);
  }

  fetch(ajaxUrl, {
    method: 'POST',
    credentials: 'same-origin',
    body,
  })
    .then((res) => res.json())
    .then((res) => {
      if (!res.success || !res.data.html) {
        container.innerHTML = '<p class="search-overlay-no-results">No results found.</p>';
        return;
      }
      container.innerHTML = res.data.html;
    })
    .catch(() => {
      container.innerHTML = '<p class="search-overlay-no-results">Something went wrong. Please try again.</p>';
    });
}

export default initSearchOverlay;
